export default __webpack_public_path__ + "static/media/factory_viewer_card.5172462f.jpg";